import useCountDown from "./useCountDown";

/**
 * Composes over useCountDown where it extracts the individual units of time
 * from the provided moment.duration object from useCountDown refreshing every second.
 * It can be used to easily construct countdown strings or components. Once it reaches zero
 * it will stop refreshing and stay at zero.
 *
 * Example use:
 * ```
 * const {hours, minutes} = useCountDownTime(moment().add(1, "hour"));
 * return `${hours}hrs {minutes < 10 ? "0" + minutes : minutes}mins`;
 *```
 * @param {String} end
 * @returns {Object} - duration
 * @returns {Number} - duration.days
 * @returns {Number} - duration.hours
 * @returns {Number} - duration.minutes
 * @returns {Number} - duration.seconds
 * @returns {Boolean} - duration.hasFinished
 * @returns {import("moment").Duration} - duration.duration
 */
const useCountDownTime = end => {
    const {duration, hasFinished} = useCountDown(end);

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    return {days, hours, minutes, seconds, hasFinished, duration};
};

export default useCountDownTime;
